<template>
  <div ref="root" class="td-course-wrap" :class="{ 'td-course-zh': zh }">
    <section class="td-course" :aria-labelledby="'td-course-' + placement">
      <h2 :id="'td-course-' + placement">{{ t.title }}</h2>
      <p>{{ t.body }}</p>
      <p class="td-course-links">
        <a class="td-course-main" v-bind="out(TD_COURSES.guide)">{{ t.guide }} ↗︎</a>
        <a class="td-course-sub" v-bind="out(TD_COURSES.primer)">{{ t.primer }} ↗︎</a>
      </p>
    </section>
  </div>
</template>
<script setup>
// TouchDesigner 課程卡（2026-10-18 TD 漏斗）：TD Daily 作品頁頁底與 /td/ 索引頁共用同一張。
// 主連結＝TD 課程站新手指南，次連結＝開課快手前導班；連結走 courseHref（utm_campaign=td-daily、utm_content=<作品 slug 或 index>），
// 事件沿用 course_click／course_impression（course-link.mjs），這裡只呼叫既有函式。
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { TD_COURSES, courseHref, observeImpressions, trackCourseClick } from '@/components/teaching/course-link.mjs'

const props = defineProps({ zh: Boolean, content: { type: String, default: 'index' }, placement: { type: String, default: 'td-daily' } })
const lang = computed(() => (props.zh ? 'zh' : 'en'))
const root = ref(null)
const TEXT = {
  zh: { title: '想學 TouchDesigner？', body: 'MONOLAB 的 TouchDesigner 課程站有新手指南、單元地圖和每個單元的筆記。', guide: '看新手指南', primer: '到開課快手看前導班' },
  en: { title: 'Want to learn TouchDesigner?', body: 'The MONOLAB course site has a beginner guide, a map of the course units and notes for each unit.', guide: 'Read the beginner guide', primer: 'See the primer course' },
}
const t = computed(() => TEXT[lang.value])
const out = (course) => ({
  href: courseHref(course, props.placement, lang.value, { campaign: 'td-daily', content: props.content }),
  target: '_blank', rel: 'noopener',
  'data-course': course.slug, 'data-placement': props.placement,
  onClick: () => trackCourseClick(course, props.placement, lang.value),
})
let stop = () => {}
onMounted(() => { stop = observeImpressions(root.value, (slug) => Object.values(TD_COURSES).find((c) => c.slug === slug), lang.value) })
onBeforeUnmount(() => stop())
</script>
<style scoped>
.td-course-wrap { background: #080808; color: #f2eee5; padding: 0 max(24px, 5vw) 96px; max-width: 1840px; margin: auto; text-align: left; font-family: var(--font-body); }
.td-course { border-top: 1px solid #38362f; padding-top: 48px; max-width: 46em; }
.td-course h2 { font-family: var(--font-slab), var(--font-display); font-size: clamp(24px, 2.4vw, 34px); font-weight: 500; line-height: 1.3; margin: 0 0 14px; }
.td-course p { margin: 0 0 20px; color: #b8b5ad; font-size: 16px; line-height: 1.85; }
.td-course .td-course-links { display: flex; flex-wrap: wrap; gap: 10px; margin: 0; }
.td-course-links a { display: inline-flex; align-items: center; min-height: 44px; padding: 8px 20px; border-radius: var(--r-pill); font-size: 15px; text-decoration: none; color: #f2eee5; background: rgba(255, 255, 255, .08); transition: background .2s, color .2s; }
.td-course-links a.td-course-main { background: var(--gold-tint); color: var(--gold); }
.td-course-links a:hover { background: rgba(255, 255, 255, .16); color: var(--gold); }
.td-course-links a:focus-visible { outline: 2px solid var(--gold); outline-offset: 4px; }
@media (max-width: 700px) { .td-course-wrap { padding-bottom: 64px; } .td-course-links a { flex: 1 1 100%; justify-content: center; } }
</style>
